/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from 'react';
import BaseComponent from './BaseCom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons'
import '../css/style.css';
import { Link } from 'react-router-dom';
import LoadingAlert from './LoadingAlert';
import { qreq } from '../shared/qrequest';
import DataTable from './DataTable';
import { withParamsAndNavigate } from './WithParamsAndNavigate';
import Alert from './Alert';
import { SidebarGlobal } from './_SidebarGlobal';
import Icon from './Icon';
import { Pop } from './PopModal';
import FormInput from './FormInput';
import Tick from './Tick';
import { TabsNav, TabsNavItem } from './TabsNav';
import L from "./Lang";

class Users extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            list: [],
            loading: true,
            loaded: false,
            query: {}
        };
        this.load = this.load.bind(this);
        this.impersonate = this.impersonate.bind(this);
        this.search = this.search.bind(this);
        this.tick = this.tick.bind(this);
    }

    componentDidMount() {
        this.load(null, this.state.showDisabled, this.props.params.tab);

        this.fillList('/api/organization/list', 'organizations', true);

        if (!this.props.params?.tab) {
            setTimeout(() => this.props.navigate('/user/all'), 100);
        }
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    componentDidUpdate(prevProps) {
        if (this.props.params.tab !== prevProps.params.tab) {
            this.load(null, this.state.showDisabled, this.props.params.tab);
        }
    }

    load(search, showDisabled, tab, sort) {
        if (tab === 'all')
            tab = null;
        this.setState({ loading: true, showDisabled: showDisabled });
        qreq.get('/api/user/list?showDisabled='
            + (showDisabled ? 'true' : 'false')
            + (search ? '&search=' + search : '')
            + (tab ? '&organizationID=' + tab : '')
            + (sort ? '&sort=' + encodeURIComponent(JSON.stringify(sort)) : '')
            , j => {
                if (j.errorCode)
                    this.setState({ errorMessage: j.errorMessage });
                else {
                    this.state.list = j.list;
                    this.setState({ list: this.state.list });
                }
                this.setState({ loading: false, loaded: true });
            }, () => {
                this.setState({ loading: false, loaded: true, errorMessage: 'Unknown error ocurred.' });
            });
    }

    impersonate(user) {
        Pop.showConfirm(<>Do you want to impersonate user '{user.name}'?</>, 'Impersonate', () => {
            qreq.post('/api/user/impersonate', user, j => {
                if (j.errorCode === 0)
                    document.location.replace('/');
                else
                    this.alert(j.errorMessage);
            });
        });
    }

    search() {
        this.setState({ query: { ...this.state.query } });
    }

    tick() {
        if (this.state.query.search !== this.state.query.lastSearch) {
            this.setState({ query: { ...this.state.query, lastSearch: this.state.query.search } });
            this.load(this.state.query.search, this.state.showDisabled);
        }
    }

    sort = (v) => {
        this.load(this.state.query.search, this.state.showDisabled, this.props.params.tab, v);
    }

    render() {

        const org = this.state.organizations?.find(o => o.id === parseInt(this.props.params.tab));

        const header = org ? <h1>{org.name}</h1> : <h1><L>All Users</L></h1>;

        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />

        SidebarGlobal.setSubNav(<><div className="btn-group">
            <button type="button" className="btn btn-primary" onClick={() => this.props.navigate('/user/new')}><FontAwesomeIcon icon={fa.faPlus} /> <span className="d-none d-md-inline"><L>New User</L></span></button>
            <button type="button" className="btn btn-secondary" onClick={() => this.load(null, !this.state.showDisabled)}>{this.state.showDisabled ? <><Icon icon="faEyeSlash" /> <span className="d-none d-md-inline"><L>Hide</L></span></> : <><Icon icon="faEye" /> <span className="d-none d-md-inline"><L>Show</L></span></>} <span className="d-none d-md-inline"><L>Disabled</L></span></button>
            <button type="button" className="btn btn-secondary" onClick={() => this.load()}><FontAwesomeIcon icon={fa.faRefresh} /> <span className="d-none d-md-inline"><L>Refresh</L></span></button>
        </div></>);



        return (
            <div className="container-fluid">
                <TabsNav>
                    <TabsNavItem to="/user/all" title="All Users" />
                    {this.state.organizations?.map((org, i) => <TabsNavItem key={i} to={'/user/' + org.id} title={org.name} />)}
                </TabsNav>
                {header}
                <Tick onTick={this.tick} />
                <div className="mb-3">
                    <FormInput model={this.state.query} name="search" label="Search for a user..." labelAsPlaceholder onChange={() => this.search()} />
                </div>
                <DataTable columns={[
                    { icon: 'Pencil', link: '/user/edit/:id', tooltip: 'Edit User' },
                    { icon: 'Lock', onClick: (obj) => this.impersonate(obj), tooltip: 'Impersonate User' },
                    { name: 'id', title: 'ID', link: '/user/edit/:id', tooltip: 'Edit User', className: 'd-none d-md-table-cell', noSort: true },
                    {
                        name: 'fullName', title: 'Full Name', link: '/user/edit/:id', tooltip: 'Edit User', valueFunc: row => {
                            if (row.isOnline)
                                return <><span>{row.name}</span> <Icon icon="faGlobe" className="text-success" title="Is Online" /></>;
                            return row.name;
                        }
                    },
                    { name: 'username', title: 'Email/Username', link: '/user/edit/:id', tooltip: 'Edit User', className: 'd-none d-md-table-cell' },
                    {
                        name: 'organizationName', title: 'Organization', className: 'd-none d-md-table-cell', valueFunc:
                            row => row.organization?.name ? <Link to={'/user/' + row.organization.id}>{row.organization.name}</Link> : 'N/A',
                        noSort: true
                    },
                    { name: 'roleGroupName', title: 'Role' },
                    { name: 'status', title: 'Status', className: 'd-none d-md-table-cell', noSort: true },
                    { name: 'lastSeenDate', title: 'Last Seen', format: 'datetime', className: 'd-none d-md-table-cell' },
                    { name: 'createdDate', title: 'Created', format: 'datetime', className: 'd-none d-md-table-cell' }
                ]}
                    data={this.state.list}
                    loading={this.state.loading}
                    onSort={this.sort}
                    sortListAPI="/api/user/sortlist"
                />
            </div>
        );
    }
}

export default withParamsAndNavigate(Users);